export default __webpack_public_path__ + "static/media/Digicat.8e1ae819.png";